/**
 * API base URL for fetch calls.
 * - In browser: always use '' (same origin) so one build works on any domain.
 * - In Node (e.g. tests): use REACT_APP_API_URL or http://localhost:3001.
 */
export function getApiBaseUrl() {
  if (typeof window !== 'undefined') {
    return '';
  }
  const env = process.env.REACT_APP_API_URL;
  const hasEnv = env != null && String(env).trim() !== '';
  return hasEnv ? String(env).replace(/\/$/, '') : 'http://localhost:3001';
}
